import * as Cesium from "cesium";
import styled from "styled-components";
import { matchPath } from "react-router";
import { useDispatch } from "react-redux";
import SidebarNav from "./layout/SidebarNav";
import SidebarDrawer from "./layout/SidebarDrawer";
import useViewerStore from '../../store-zustand/viewer';
import { useHistory, Redirect } from "react-router-dom";
import useProjectStore from "../../store-zustand/project";
import React, { useEffect, useRef, useState } from "react";
import useSearchStore from '../../store-zustand/searchbar';
import { ClearGlobalVariables, clearProjectVariablesFromViewer } from '../MapView/MapUtils';

const Wrapper = styled.aside`
  overflow: hidden;
  max-height: 100vh;
  background: ${({ theme }) => theme.backgroundColor.body};
  transition: all 0.35s;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.desktopMin}) {
    display: flex;
    width: 5rem;
    &.drawer-open {
      width: 44.6rem;
    }
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 46px;
    &.drawer-open {
      height: 100%;
    }
  }
`;

const Sidebar = (props) => {
  var drawerMatch = matchPath(window.location.pathname, {
    path: "/:drawer",
  });

  var projectMatch = matchPath(window.location.pathname, {
    path: "/:drawer/:projectId",
  });

  let drawer = drawerMatch?.params.drawer;
  const sidebars = ["profile", "search", "projects", "layers", "apps", "dashboard", "info"];
  const [drawerContent, setDrawerContent] = useState(drawer ? drawer : "search");
  const { project_id, setproject_id, getprojectdataByid } = useProjectStore();
  const [drawerOpen, setDrawerOpen] = useState(props.drawerOpen);
  const { setkeywords_response } = useSearchStore();
  const { viewer, setsearch_result_visibility, setmapboxvisibility } = useViewerStore();
  const node = useRef();

  const dispatch = useDispatch();
  const history = useHistory();

  const onClose = () => {
    setDrawerOpen(false);
    history.push("/");
  };

  const handleSidebarNavClick = (navItem) => {
    setkeywords_response();
    setsearch_result_visibility(false);
    if (navItem === drawerContent) {
      setDrawerOpen(!drawerOpen)
    } else {
      dispatch({ type: 'TOGGLE_MAP_TOOL', show: false });
      dispatch({ type: 'TOGGLE_DATE_PAGINATOR', show: false });
      dispatch({ type: 'TOGGLE_DATA_DOWNLOAD_MODAL', show: false });
      dispatch({ type: "TOGGLE_COMPARE_TOOL", compareTool: false });
      setmapboxvisibility(0);
      ClearGlobalVariables(viewer);
      clearProjectVariablesFromViewer(viewer);
      document.getElementById("cesium-wrapper").style.cursor = 'default';
      if (!drawerOpen) setDrawerOpen(true);
    }

    if (navItem === "info") {
      dispatch({ type: 'TOGGLE_GUIDED_TOUR', show: true });
    }
    setDrawerContent(navItem);
  };

  useEffect(() => {
    async function fetchDataToZoom() {
      const project_info = await getprojectdataByid(parseInt(projectMatch.params.projectId));
      if (project_info !== undefined && project_info !== "Error") {
        let BBOXData = project_info[0].fields?.BBOX.replaceAll("[", "");
        BBOXData = BBOXData?.replaceAll("]", "");
        BBOXData = BBOXData?.replaceAll("'", "");
        let rectangle = BBOXData?.split(",");

        rectangle && viewer && (
          viewer.camera.flyTo({
            destination: Cesium.Rectangle.fromDegrees(parseFloat(rectangle[0]), parseFloat(rectangle[2]), parseFloat(rectangle[1]), parseFloat(rectangle[3]))
          })
        );
      } else {
        console.log("fetchDataToZoom: Project not found")
      }
    }

    if (projectMatch && viewer) {
      setproject_id(parseInt(projectMatch.params.projectId));
      fetchDataToZoom()
    }
  }, [viewer])

  const handleCreate = (project) => {
    setDrawerContent("projects");
  };

  const goToCesiumIonPage = () => {
    setDrawerContent("cesium");
  };

  const goToWebMapServicePage = () => {
    setDrawerContent("webservice");
  };

  const goToAPIPage = () => {
    setDrawerContent("api");
  }

  const goToProfilePage = () => {
    setDrawerContent("profile");
  };

  return (  
    !drawer || sidebars.includes(drawer) ?
      <Wrapper ref={node} className={(sidebars.includes(drawer) && drawerOpen) ? "drawer-open" : null}>
        <SidebarNav activeClass={drawerOpen ? drawerContent : null} handleSidebarNavClick={handleSidebarNavClick}/>
        <SidebarDrawer
          content={drawerContent}
          onClose={onClose}
          onCreate={handleCreate}
          project={project_id}
          goToCesiumIonPage={goToCesiumIonPage}
          goToWebMapServicePage={goToWebMapServicePage}
          goToAPIPage={goToAPIPage}
          goToProfilePage={goToProfilePage} />
      </Wrapper> : 
      <Redirect to="/" />
  );
};

export default Sidebar;